import { createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { Trans } from "react-i18next";



const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            color: "#757575"
        },
        hyperLink: {
            color: theme.palette.secondary.main,
            textDecoration: 'none'
        }
    })
)

export function FormTermsLabel() {
    const classes = useStyles();
    return <div className={classes.root}>
        <Trans i18nKey="signup.form.terms">
            0<a className={classes.hyperLink} href="https://y-e.co/terms/MerchantAgreement.pdf"
                rel="noopener noreferrer" target="_blank">1</a>2
        </Trans>
    </div>

}